export class DiaryNote {

    constructor(
        public id: string,
        public startDate: Date,
        public endDate: Date,
        public note: string
    ) { }

    occursOnDate(date: Date): boolean {
        const targetDateStart = new Date(date)
        targetDateStart.setHours(0, 0, 0, 0)
        const targetDateEnd = new Date(date)
        targetDateEnd.setHours(23, 59, 59, 999)
        return this.startDate <= targetDateEnd && this.endDate >= targetDateStart
    }
}
